import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { evidenceFileType } from '@/config/dic';
import UploadConfig from '@/class/upload.config';
import downloadFile from '@/apis/downloadFile';
var uploadConfigIns = new UploadConfig();

var EvidenceCard = /*#__PURE__*/function (_Vue) {
  _inherits(EvidenceCard, _Vue);

  var _super = _createSuper(EvidenceCard);

  function EvidenceCard() {
    var _this;

    _classCallCheck(this, EvidenceCard);

    _this = _super.call(this);
    _this.url = '';
    _this.type = {
      image: require('@/assets/icons/image.svg'),
      mp4: require('@/assets/icons/mp4.svg'),
      other: require('@/assets/icons/other.svg')
    };
    return _this;
  }

  _createClass(EvidenceCard, [{
    key: "getImageUrl",
    value: function getImageUrl(url, type, id) {}
  }, {
    key: "handleClick",
    value: function handleClick(url, type, id) {
      // console.log('handle click', url, type, id)
      if (this.downUrl) {
        this.getImageUrl(url, type, id);
      }
    }
  }, {
    key: "deleteCase",
    value: function deleteCase(e) {
      e.stopPropagation();
      return this.id;
    }
  }, {
    key: "downloadCase",
    value: function downloadCase(e) {
      e.stopPropagation();
      var host = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_SYSTEMADDRESS : "".concat(window.location.protocol, "//").concat(window.location.host); // const host = process.env.NODE_ENV === 'development' ? 'https://ts-pre.hikyun.com:446' : `${window.location.protocol}//${window.location.host}`

      this.url = "".concat(host).concat(downloadFile, "?id=").concat(this.id);
    }
  }, {
    key: "countSize",
    value: function countSize(size) {
      // console.log('size', size, (+size).toFixed(2))
      if (+size) return uploadConfigIns.countSize(+size);
      return '0B';
    }
  }, {
    key: "fileSuffixType",
    value: function fileSuffixType(suffix) {
      var suf = suffix.slice(1, suffix.length).toLowerCase();
      var res = [];
      if (evidenceFileType.doc.split(',').indexOf(suf) !== -1) res = [this.type.other]; // 文本文件
      else if (evidenceFileType.pdf.split(',').indexOf(suf) !== -1) res = [this.type.other]; // pdf文件
        else if (evidenceFileType.image.split(',').indexOf(suf) !== -1) res = [this.type.image]; // 图片文件
          else if (evidenceFileType.mp4.split(',').indexOf(suf) !== -1) res = [this.type.mp4]; // 音频文件
            else if (evidenceFileType.rar.split(',').indexOf(suf) !== -1) res = [this.type.other]; // 压缩文件
              else res = [this.type.other];
      return res;
    }
  }]);

  return EvidenceCard;
}(Vue);

__decorate([Prop({
  type: String,
  default: function _default() {
    return '';
  }
})], EvidenceCard.prototype, "id", void 0);

__decorate([Prop({
  type: String,
  default: function _default() {
    return '';
  }
})], EvidenceCard.prototype, "activeId", void 0);

__decorate([Prop({
  type: String,
  default: function _default() {
    return '';
  }
})], EvidenceCard.prototype, "fileType", void 0);

__decorate([Prop({
  type: String,
  default: function _default() {
    return '';
  }
})], EvidenceCard.prototype, "downUrl", void 0);

__decorate([Prop({
  type: String,
  default: function _default() {
    return '';
  }
})], EvidenceCard.prototype, "fileUrl", void 0);

__decorate([Prop({
  type: String,
  required: true
})], EvidenceCard.prototype, "fileName", void 0);

__decorate([Prop({
  type: String,
  required: true
})], EvidenceCard.prototype, "fileSize", void 0);

__decorate([Prop({
  type: String,
  required: true
})], EvidenceCard.prototype, "date", void 0);

__decorate([Prop({
  type: Boolean,
  required: true,
  default: true
})], EvidenceCard.prototype, "showDelete", void 0);

__decorate([Emit('getImageUrl')], EvidenceCard.prototype, "getImageUrl", null);

__decorate([Emit('deleteCase')], EvidenceCard.prototype, "deleteCase", null);

EvidenceCard = __decorate([Component], EvidenceCard);
export default EvidenceCard;